//CouncilMeeting
const CouncilMeetingWaitingRoom = () =>
    import('@pages/management/council/CouncilMeetingWaitingRoom')
const CouncilMeetingModule = () =>
    import('@pages/management/council/CouncilMeetingModule')
const CouncilMeetingRoom = () =>
    import('@pages/management/council/CouncilMeetingRoom')

import authGuard from '../authGuard'

export default {
    path: '/council-meetings',
    component: CouncilMeetingModule,
    children: [{
            path: 'waiting-room',
            component: CouncilMeetingWaitingRoom,
            name: 'councilMeetingWaitingRoom',
        },
        {
            path: 'meeting-room',
            component: CouncilMeetingRoom,
            name: 'councilMeetingRoom',
        },
    ],
    beforeEnter: authGuard,
}
